import { render, staticRenderFns } from "./EarlyInpatientAssessment.vue?vue&type=template&id=3e989f40&scoped=true"
import script from "./EarlyInpatientAssessment.vue?vue&type=script&lang=js"
export * from "./EarlyInpatientAssessment.vue?vue&type=script&lang=js"
import style0 from "./EarlyInpatientAssessment.vue?vue&type=style&index=0&id=3e989f40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e989f40",
  null
  
)

export default component.exports